import React, { useEffect, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes as ReactRoutes } from 'react-router-dom';

import BuildIos from './Pages/Build/Build';
import BuildAndroid from './Pages/BuildAndroid/BuildAndroid';
import DashboardAndroid from './Pages/DashboardAndroid/DashboardAndroid';
import GitLabCallback from './Pages/GitLabCallback/GitLabCallback';
import Home from './Pages/Home/Home';
import Login from './Pages/Login/Login';
import StatusS1 from './Pages/S1Mobile/StatusS1/StatusS1';
import Status from './Pages/Status/Status';
import Versions from './Pages/Versions/Versions';
import { StorageEnum } from './utils/enumerators/Storage.enum';
import { validateToken } from './utils/services/gitlab-service';

const Routes = () => {
	const [loading, setLoading] = useState(true);

	const ProtectedRoute = ({ children }) => {
		if (loading) {
			return children;
		}
		const token = localStorage.getItem(StorageEnum.GITLAB_TOKEN);
		const login = (
			<Navigate
				to="/login"
				replace
			/>
		);
		if (!token) {
			return login;
		}
		return children;
	};

	useEffect(async () => {
		if (document.location.pathname == '/gitlab/callback') {
			setLoading(false);
			return;
		}

		validateToken(() => {
			setLoading(false);
		});
	}, []);

	return (
		<>
			{loading && <span className="message centered">Carregando...</span>}

			{!loading && (
				<BrowserRouter>
					<ReactRoutes>
						<Route
							path="/"
							exact
							element={
								<ProtectedRoute>
									<Home />
								</ProtectedRoute>
							}
						/>
						<Route
							element={
								<ProtectedRoute>
									<BuildIos />
								</ProtectedRoute>
							}
							path="/build-ios"
						/>
						<Route
							element={
								<ProtectedRoute>
									<BuildAndroid />
								</ProtectedRoute>
							}
							path="/build-android"
						/>
						<Route
							element={
								<ProtectedRoute>
									<DashboardAndroid />
								</ProtectedRoute>
							}
							path="/dashboard-android"
						/>
						<Route
							element={
								<ProtectedRoute>
									<Versions />
								</ProtectedRoute>
							}
							path="/versions"
						/>
						<Route
							element={
								<ProtectedRoute>
									<Status />
								</ProtectedRoute>
							}
							path="/status"
						/>
						<Route
							element={
								<ProtectedRoute>
									<StatusS1 />
								</ProtectedRoute>
							}
							path="/s1-mobile/status"
						/>

						<Route
							element={<Login />}
							path="/login"
						/>
						<Route
							element={<GitLabCallback />}
							path="/gitlab/callback"
						/>
					</ReactRoutes>
				</BrowserRouter>
			)}
		</>
	);
};

export default Routes;
